import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'craft_n_draft';
// export const customerGroup = 'default_in_preparation';

const supportEmail = {
	[customerGroup]: 'craft_and_draft@smoothr.de',
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyDEotTdHGF5Q_Vi5Nx8ogTSl-uaO6PwMjQ',
		authDomain: 'craft_and_draft.firebaseapp.com',
		projectId: 'craft_and_draft',
		storageBucket: 'craft_and_draft.firebasestorage.app',
		messagingSenderId: '879121573408',
		appId: '1:879121573408:web:0b005e4a6f3fa103b1be45',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyBxctZyYOPXBxP8pv-IsX0F3y16TB3nCFU',
	baseUrl: 'https://api.smoothr.de',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	allergens_link: '',
	hasRecommendations: true,
	...apiEnvironment,
	hjid: 5035140,
	merchantId: '3000033036',
	merchantGPay: 'BCR2DN7TRCR2NIBO',
	merchantGoogleId: 'BCR2DN7TRCR2NIBO',
};
